<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout>
        <h1><span>{{title}}</span></h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mx-1" dark @click="save">Сохранить</v-btn>
        <v-btn color="primary" class="mx-1" dark @click="clear">Очистить</v-btn>
        <v-btn color="primary" class="ml-1 mr-0" dark @click="goBack">Вернуться</v-btn>
      </v-layout>
      <v-alert :value="alert" type="success">Вопрос сохранен</v-alert>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-textarea tabindex="1" label="Текст" :rules="requiredRules" v-model="editedItem.text"/>
            </v-flex>
            <v-flex xs6 pr-2>
              <v-text-field tabindex="2" :rules="requiredRules" label="Номер" v-model.number="editedItem.number"
                            type="number"/>
            </v-flex>
            <v-flex xs6 pl-2>
              <v-select :items="categories" tabindex="3" v-model="editedItem.category" :rules="requiredRules"
                        label="Категория"
                        persistent-hint/>
            </v-flex>
            <v-flex xs12>
              <v-checkbox class="mb-0 checkbox-fix" :error-count="0" v-model="editedItem.needFixAnswers"
                          label="Не перемешивать варианты ответы"></v-checkbox>
              <v-radio-group v-model="editedItem.rightAnswer.id" :rules="radioRules">
                <v-layout v-for="(item, index) in editedItem.answers" :key="item.id">
                  <v-radio :value="item.id" tabindex="5"/>
                  <v-text-field tabindex="4" :rules="requiredRules" :label="'Вариант '+(index+1)" v-model="item.text"/>
                </v-layout>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import CategoryService from '@/services/CategoryService'
import ObjectUtils from '@/utils/ObjectUtils'
import Dialog from '@/components/fragments/Dialog'
import TestQuestionService from '@/services/TestQuestionService'

export default {
  props: {
    question: Object,
    editing: false
  },
  components: {Dialog},
  data: () => ({
    alert: false,
    categories: CategoryService.getList(),
    valid: true,
    requiredRules: [
      v => !!v || 'Должно быть заполнено'
    ],
    radioRules: [
      v => v > -1 || 'Выберите правильный вариант'
    ],
    defaultItem: TestQuestionService.getDefaultItem(),
    editedItem: {},
    testQuestionService: undefined
  }),
  computed: {
    title () {
      return this.editing ? 'Редактирование вопроса' : 'Добавление вопроса'
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {
    save () {
      this.alert = false
      if (this.$refs.form.validate()) {
        this.testQuestionService.saveItem(this.editedItem, this.editing, (data) => {
          if (data.status) {
            this.alert = true
            if (!this.editing) this.clear()
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    clear () {
      this.$refs.form.reset()
      this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
    }
  },
  created () {
    this.testQuestionService = new TestQuestionService(this.$store)
    this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
  },
  watch: {
    question (val) {
      this.editedItem = ObjectUtils.jsonCopy(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-fix /deep/ {
  .v-input__slot {
    margin-bottom: 0;
  }

  .v-messages {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/test/EditForm.vue